import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const Subheader = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 20,
  fontWeight: "bold"
}));

export default Subheader;